'use client';

import React from 'react';
import FrWeddingNav from '@/components/FrWeddingNav';
import Image from 'next/image';
import { getTranslations } from '@/lib/i18n';

export default function FrThemePage() {
  const t = getTranslations('fr');

  return (
    <main className="bg-buttermilk min-h-screen">
      <FrWeddingNav />
      <section className="relative w-full overflow-hidden" style={{ height: '75vh' }}>
        <Image
          src="/assets/images/IMG_7429-1777460768896.JPG"
          alt="Tissu shibori indigo teint à la main avec des motifs traditionnels japonais de teinture à la ficelle en tons bleu profond"
          fill
          priority
          className="object-cover"
          style={{ objectPosition: 'center 30%' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-deep-navy/5 to-deep-navy/65" />
        <div className="absolute bottom-0 left-0 right-0 z-10 px-8 md:px-16 xl:px-24 pb-10 lg:pb-16 max-w-screen-2xl mx-auto w-full">
          <p className="section-label text-warm-sand mb-4">{t?.theme?.heroLabel}</p>
          <h1 className="font-serif text-display-md text-off-white">
            L'inspiration derrière la journée
          </h1>
        </div>
      </section>
      <section className="px-8 md:px-16 xl:px-24 pt-16 pb-24 max-w-screen-2xl mx-auto">
        <div className="max-w-2xl">
          <p className="font-sans text-stone text-base md:text-lg leading-relaxed mb-6">
            Dartmouth, avec ses couleurs, son histoire et son magnifique cadre côtier, forme la toile de fond d'une journée façonnée par les lieux et les influences qui nous tiennent le plus à cœur.
          </p>
          <p className="font-sans text-stone text-base md:text-lg leading-relaxed mb-6">
            L'atmosphère de la journée s'enracine dans un mariage d'été traditionnel, avec une élégance discrète, des détails soignés et un lien profond avec la mer et le paysage environnant. Le bleu est au cœur de tout cela, traversant la journée en tons côtiers riches, indigo et encre, doucement façonné par l'histoire maritime de Dartmouth et la beauté naturelle du cadre.
          </p>
          <p className="font-sans text-stone text-base md:text-lg leading-relaxed mb-6">
            Vous remarquerez peut-être de subtiles références tissées tout au long de la journée dans les textures, les couleurs et les petits détails, avec un très doux clin d'œil au Japon à travers la simplicité, l'artisanat et le design réfléchi, équilibré par un fil écossais qui célèbre notre héritage familial commun.
          </p>
          <p className="font-sans text-stone text-base md:text-lg leading-relaxed mb-6">
            Si vous souhaitez vous inspirer ou prendre des repères du thème général, nous vous invitons à le faire d'une manière qui vous convient.
          </p>
          <p className="font-sans text-stone text-base md:text-lg leading-relaxed">
            Avant tout, nous voulons que vous vous sentiez à l'aise et que vous portiez quelque chose qui vous ressemble le plus. Pour plus d'informations, veuillez consulter les FAQ imaginées, ou n'hésitez pas à nous appeler ou nous envoyer un message à tout moment. Nous avons hâte de voir vos interprétations, votre créativité et votre individualité s'exprimer le jour J.
          </p>
          <a
            href="/assets/images/IMG_1333-1777421961720.JPG"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-8 font-sans text-sm text-stone underline underline-offset-2 hover:opacity-70 transition-opacity"
          >
            {t?.theme?.viewMoodboard}
          </a>

          <div className="mt-12 w-full relative">
            <Image
              src="/assets/images/56decb6b-32c8-4163-b585-bab0ec74c278-1777462958221.JPG"
              alt="Port de Dartmouth avec des bateaux colorés amarrés le long du front de mer"
              width={1200}
              height={900}
              className="w-full h-auto"
              style={{ display: 'block' }}
            />
            <span className="absolute bottom-2 right-2 text-white/70" style={{ fontSize: '9px', letterSpacing: '0.02em' }}>
              Embouchure de la Dart, déc. 25
            </span>
          </div>
        </div>
      </section>
    </main>
  );
}
